module.exports = __webpack_public_path__ + "img/c1-m.4fa97390.jpg";